<template>
    <img :src="iconSrc" :alt="ariaLabel" />
</template>

<script>
import { computed } from 'vue'
import iconIdle from './assets/DLS-AI-Badge-Idle.svg'
import iconWorking from './assets/DLS-AI-Badge-Working.svg'
import iconComplete from './assets/DLS-AI-Badge-Complete.svg'

export default {
    props: {
        // Selects which SVG file renders. Animation, colors, and reduced-motion
        // handling are all baked into the SVG files themselves — the component is
        // a stateless picker. Consumers size with Tailwind classes (e.g. class="w-5
        // h-5"); badge SVGs have a near-square 76:84 viewBox.
        state: {
            type: String,
            default: 'idle',
            validator: (v) => ['idle', 'working', 'complete'].includes(v)
        }
    },
    setup(props) {
        // Computed
        const iconSrc = computed(() => ({
            working: iconWorking,
            complete: iconComplete
        }[props.state] || iconIdle))
        const ariaLabel = computed(() => ({
            working: 'DLS AI working',
            complete: 'DLS AI complete'
        }[props.state] || 'DLS AI'))

        return { iconSrc, ariaLabel }
    }
}
</script>
